import styled from 'styled-components';
import { SliderV2 as CustomSlider } from 'pfm-ui-components';
import { up } from 'styled-breakpoints';
import { pxToRem } from '../../../styles/utils';

interface CarouselProps {
  id: string;
  device: string;
  children: any;
  desktopSlidesToShow?: number;
  enableAutoPlay?: boolean;
  infiniteScroll?: boolean;
  shouldShowDots?: boolean;
  shouldShowArrow?: boolean;
  isLoginSlider?: boolean;
}

const ContainerWrapper = styled.article`
  width: 98%;
  padding-left: ${pxToRem(4)};
  ${up('md')} {
    width: 45%;
    padding-left: ${pxToRem(12)};
  }
`;

const Carousel1 = (props: CarouselProps) => {
  const {
    isLoginSlider,
    shouldShowArrow,
    id,
    device,
    children,
    desktopSlidesToShow,
    enableAutoPlay,
    infiniteScroll,
    shouldShowDots,
  } = props;
  return (
    <CustomSlider
      id={id}
      isLoginSlider={isLoginSlider}
      shouldShowArrow={shouldShowArrow}
      device={device}
      desktopSlidesToShow={desktopSlidesToShow}
      enableAutoPlay={enableAutoPlay}
      infiniteScroll={infiniteScroll}
      shouldShowDots={shouldShowDots}
    >
      {children.map((bannerComponent: JSX.ElementChildrenAttribute, index: number) => (
        <ContainerWrapper key={index}>{bannerComponent}</ContainerWrapper>
      ))}
    </CustomSlider>
  );
};

export default Carousel1;
